import { Loader2Icon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

const ChannelCard = ({
  title,
  description,
  avatar,
  isConnected,
  connectedUsername,
  onConnect,
  loading,
  connectionType,
  currentConnectionType,
}) => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/inbox');
  };
  return (
    <Card className='cursor-pointer transition-shadow hover:shadow-lg'>
      <CardHeader className='text-center'>
        <div className='mb-4 flex justify-center'>
          <div className='h-16 w-16 overflow-hidden'>
            <img
              src={avatar}
              alt={title}
              className='h-full w-full object-cover'
            />
          </div>
        </div>
        <CardTitle className='text-xl'>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className='text-center'>
        {isConnected ? (
          <div className='space-y-4'>
            <div className='flex items-center justify-center gap-3'>
              <div className='h-3 w-3 rounded-full bg-green-500'></div>
              <span className='font-medium text-green-600'>Connected</span>
            </div>
            <p className='text-sm text-muted-foreground'>
              @{connectedUsername}
            </p>
            <Button
              variant='outline'
              onClick={handleContinue}
              className='w-full'
            >
              Continue to Inbox
            </Button>
          </div>
        ) : (
          <Button
            onClick={onConnect}
            disabled={loading && connectionType === currentConnectionType}
            className='w-full'
          >
            {loading && connectionType === currentConnectionType ? (
              <>
                <Loader2Icon className='mr-2 h-4 w-4 animate-spin' />
                Connecting...
              </>
            ) : (
              <>Connect {title}</>
            )}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default ChannelCard;
